import { Description } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useState } from "react";
import useService from "../../hooks/useService";
import { fetchTransactionDocuments } from "../../services/Transactions";
import { TRANSACTION_TYPES } from "../../utils/constant";
import { TTransactionDocumentTypes } from "../../Models/common";

const DownloadInvoice = ({ fileName, label, documentType }: { fileName: string, label:string, documentType?:TTransactionDocumentTypes }) => {
  
  const { execute, store } = useService()
  const { transactionInfo } = store.transactionsStore
  const handleDownload = async () => {
    let pdfPath = ''
    const { data } = await execute(() => fetchTransactionDocuments({
      globalTransactionNumber: transactionInfo.globalTransactionNumber!,
      transactionType: transactionInfo.transactionType,
      documentType
    }))
    if (data === null)  return

    pdfPath = data.url
    // Replace 'yourfile.pdf' with the actual path to your PDF file
    // const pdfPath = 'assets/pdf/PVC_INVOICE.pdf';

    // Set the window location to the PDF file path
    // window.open(pdfPath, '_blank');

    // Create a link element
    var link = document.createElement('a');

    // Set the href attribute to the PDF file path
    link.href = pdfPath;

    // Set the download attribute with the desired file name
    link.download = `${fileName}.pdf`;

    // Append the link to the document
    document.body.appendChild(link);

    // Trigger the click event on the link to start the download
    link.click();

    // Remove the link from the document
    document.body.removeChild(link);
  };

  return (
    <Button size="small" onClick={handleDownload} variant="outlined" startIcon={<Description />}>
      {label}
    </Button>
  );
};

export default DownloadInvoice;
